import * as types from '../actions/actionTypes';
import { assign } from 'lodash';

const initialState = {
  userInfo: [],
  vehicleInfo:[],
  popupToggle: false,
  mapInfo:{},
  driverTypes:[],
  vehicleTypes:[],
  vehicleDetails:{},
  displayloader:false,
  historyInfo:{},
  queueInfo:{},
};

export default function manageuserReducer(state = initialState, action) {
  switch (action.type) {
    case types.MANAGE_USER_INFO:
      return (assign({}, state, {
        userInfo: action.userInfo
      }));
    case types.MY_VEHICLE_INFO:
      return (assign({}, state, {
        vehicleInfo: action.vehicleInfo
      }));
    case types.MY_VEHICLE_POPUP:
      return (assign({}, state, {
        popupToggle: action.popupToggle
      }));
    case types.MY_MAPS_INFO:
      return (assign({}, state, {
        mapInfo: action.mapInfo
      }));
    case types.DRIVER_TYPES:
      return (assign({}, state, {
        driverTypes: action.driverTypes
    }));
    case types.VEHICLE_TYPES:
      return (assign({}, state, {
        vehicleTypes: action.vehicleTypes
    }));
    case types.VEHICLE_INFO:
      return (assign({}, state, {
        vehicleDetails: action.vehicleDetails
    }));
    case types.LOADER_DISPLAY:
      return (assign({}, state, {
        displayloader: action.displayloader
    }));
    case types.LIST_HISTORY:
      return (assign({}, state, {
        historyInfo: action.historyInfo
    }));
    case types.LIST_QUEUE:
      return (assign({}, state, {
        queueInfo: action.queueInfo
    }));
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/manageUserReducer.js